import { HeartHandshake } from "lucide-react";
import { Link } from "react-router-dom";
import { IoLogoYoutube } from "react-icons/io5";


export default function HealthResources() {
  return (
    <section className="max-w-7xl mx-auto px-4 py-10">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Ayushman Bharat */}
        <div className="bg-gradient-to-r from-blue-600 to-cyan-500 rounded-2xl p-6 text-white shadow-lg">
          <div className="flex items-center gap-3 mb-4">
            <HeartHandshake className="w-10 h-10" />
            <h2 className="text-2xl font-bold">Ayushman Bharat</h2>
          </div>

          <p className="text-sm text-blue-100 mb-5">
            Check your eligibility and access cashless healthcare benefits under
            the Ayushman Bharat scheme.
          </p>

          <Link
            to="/ayushman"
           
            className="inline-flex items-center bg-white text-blue-700 px-5 py-2.5 rounded-lg font-semibold hover:bg-blue-50 transition"
          >
            Check Eligibility
          </Link>
        </div>

        {/* YouTube */}
        <div className="bg-gradient-to-r from-red-600 to-red-500 rounded-2xl p-6 text-white shadow-lg">
          <div className="flex items-center gap-3 mb-4">
            <IoLogoYoutube className="w-10 h-10" />
            <h2 className="text-2xl font-bold">Health Videos</h2>
          </div>

          <p className="text-sm text-red-100 mb-5">
            Watch health awareness videos, doctor advice, and hospital updates
            on our official YouTube channel.
          </p>

          <a
            href="https://www.youtube.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center bg-white text-red-600 px-5 py-2.5 rounded-lg font-semibold hover:bg-red-50 transition"
          >
            Visit YouTube
          </a>
        </div>
      </div>
    </section>
  );
}
